// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1 figure[data-v-7211af72]{margin-top:-1.5rem}header img[data-v-7211af72]{margin:0 auto;max-width:1024px;width:100%}.section-list img[data-v-7211af72]{height:auto;margin-right:.375rem}.section-list h3[data-v-7211af72],.section-list p[data-v-7211af72]{margin:0}@media screen and (min-width:40.063em){.medium-12[data-v-7211af72]{margin-top:2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
